import { Controller } from "@hotwired/stimulus"

// Aggregates the visibility of two inline state slots ("ES|QL detected" and
// "Query modified") into a single pill in the search bar. Producers update
// the pill via Stimulus outlets, setting boolean values that flow through
// the value-changed callbacks here — the pill owns all DOM mutation.
export default class extends Controller {
  static targets = ["esqlSlot", "modifiedSlot"]
  static values = {
    esql: { type: Boolean, default: false },
    modified: { type: Boolean, default: false },
  }

  esqlValueChanged(visible) {
    if (this.hasEsqlSlotTarget) {
      this.esqlSlotTarget.classList.toggle("hidden", !visible)
    }
    this.#sync()
  }

  modifiedValueChanged(visible) {
    if (this.hasModifiedSlotTarget) {
      this.modifiedSlotTarget.classList.toggle("hidden", !visible)
    }
    this.#sync()
  }

  #sync() {
    // Only count slots that actually exist on this pill instance — a future
    // caller wiring a single-slot pill would otherwise force the container
    // hidden whenever the missing slot's value defaulted to false.
    const anyVisible =
      (this.hasEsqlSlotTarget && this.esqlValue) ||
      (this.hasModifiedSlotTarget && this.modifiedValue)
    // .hidden (display:none) and .inline-flex are both Tailwind display
    // utilities; swap exclusively so cascade order doesn't pin the pill open.
    this.element.classList.toggle("hidden", !anyVisible)
    this.element.classList.toggle("inline-flex", anyVisible)
  }
}
